import address from "@/apis/address";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";

export function useUcService() {
  const result = useQuery({
    queryKey: ["ucService"],
    queryFn: () =>
      axios.post<{ token: string }>(
        "/auth",
        {
          username: "admin",
          password: "2@26WwByzc",
        },
        {
          baseURL: address.uc,
        },
      ),
  });

  const token = result.data?.data.token;

  return token;
}
